import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, style, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-xl border-2 bg-black/50 text-white px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white/50 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        style={{
          borderColor: 'var(--color-header-accent, #0A74FF) !important',
          boxShadow: 'none !important',
          ...style
        }}
        onFocus={(e) => {
          e.currentTarget.style.setProperty('border-color', 'var(--color-header-accent, #0A74FF)', 'important');
          e.currentTarget.style.setProperty('box-shadow', `0 0 0 2px color-mix(in srgb, var(--color-header-accent, #0A74FF) 20%, transparent)`, 'important');
        }}
        onBlur={(e) => {
          e.currentTarget.style.setProperty('border-color', 'var(--color-header-accent, #0A74FF)', 'important');
          e.currentTarget.style.setProperty('box-shadow', 'none', 'important');
        }}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };